import { defineMessage } from 'services/localization';

export const messages = {
    sectionHeaderText: defineMessage('items'),
    itemColumnName: defineMessage('item'),
    descriptionColumnName: defineMessage('description'),
    qtyColumnName: defineMessage('qty_1'),
    unitPriceColumnName: defineMessage('rate'),
    amountColumnName: defineMessage('amount'),
    taxCodeColumnName: defineMessage('tax_code'),
    taxRateColumnName: defineMessage('tax_rate'),
    taxAmountColumnName: defineMessage('tax_amount'),
    grossAmountColumnName: defineMessage('gross_amount'),
    memoColumnName: defineMessage('memo'),
    departmentColumnName: defineMessage('department'),
    classColumnName: defineMessage('class'),
    locationColumnName: defineMessage('location'),
    customerColumnName: defineMessage('customerproject'),
    projectTaskColumnName: defineMessage('project_task'),
    billableColumnName: defineMessage('billable'),
    billableColumnTooltip: defineMessage('this_line_is_billable'),
    unitsColumnName: defineMessage('units'),
    vendorNameColumnName: defineMessage('vendor_name_2'),
    closedColumnName: defineMessage('closed'),
    closedColumnTooltip: defineMessage('this_line_is_closed'),
    expectedReceiptDate: defineMessage('expected_receipt_date'),
    amortizationSchedule: defineMessage('amortization_schedule'),
    amortizationStartDate: defineMessage('amortization_start_date'),
    amortizationEndDate: defineMessage('amortization_end_date'),
    amortizationResidual: defineMessage('amortization_residual'),
    linkedColumnName: defineMessage('linked_requesttype'),
    bill: defineMessage('bills'),
    po: defineMessage('po'),
    matching: defineMessage('link_1'),
};
